var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubePlayButtonIconLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 37,
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2727 37.4821C57.2121 38.6018 57.2121 41.4011 55.2727 42.5208L34.5455 54.4877C32.6061 55.6074 30.1818 54.2077 30.1818 51.9683L30.1818 28.0345C30.1818 25.7951 32.6061 24.3955 34.5455 25.5152L55.2727 37.4821Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlayButtonIconLight);
export default __webpack_public_path__ + "static/media/youtube-play-button-icon-light.36f1d37b93359013b5a8a530b84ed802.svg";
export { ForwardRef as ReactComponent };